export const PRODUCTS = [
  {
    color: 'blue',
    line: 'MULTI BALM',
    title: 'BLUE',
    name: 'RORO BLUE',
    uri: '/product/BLEU',
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7078661867',
    openImage: require('../../../asset/images/product/blue-open.png'),
    closeImage: require('../../../asset/images/product/blue-close.png'),
  },
  {
    color: 'green',
    line: 'MULTI BALM',
    title: 'VERT',
    name: 'RORO VERT',
    uri: '/product/VERT',
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7087782778',
    openImage: require('../../../asset/images/product/green-open.png'),
    closeImage: require('../../../asset/images/product/green-close.png'),
  },
  {
    color: 'red',
    line: 'MULTI BALM',
    title: 'ROUGE',
    name: 'COCO ROUGE',
    uri: '/product/ROUGE',
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7087821388',
    openImage: require('../../../asset/images/product/red-open.png'),
    closeImage: require('../../../asset/images/product/red-close.png'),
  },
  {
    color: 'pink',
    line: 'MULTI BALM',
    title: 'ROSE',
    name: 'COCO ROSE',
    uri: '/product/ROSE',
    url: 'https://smartstore.naver.com/levrai_cosmetic/products/7087807656',
    openImage: require('../../../asset/images/product/pink-open.png'),
    closeImage: require('../../../asset/images/product/pink-close.png'),
  },
  {
    color: 'yellow',
    line: 'MULTI BALM',
    title: 'SOLEIL',
    name: 'RORO SOLEIL',
    uri: '/product/SOLEIL',
    url: null,
    openImage: require('../../../asset/images/product/yellow-open.png'),
    closeImage: require('../../../asset/images/product/yellow-close.png'),
  },
  {
    color: 'white',
    line: 'MULTI BALM',
    title: 'BLANC',
    name: 'RORO BLANC',
    uri: '/product/BLANC',
    url: null,
    openImage: require('../../../asset/images/product/white-open.png'),
    closeImage: require('../../../asset/images/product/white-close.png'),
  },
];
